import { render } from "./marriageFormComponent.vue?vue&type=template&id=75285a7a&scoped=true"
import script from "./marriageFormComponent.vue?vue&type=script&lang=js"
export * from "./marriageFormComponent.vue?vue&type=script&lang=js"

import "./marriageFormComponent.vue?vue&type=style&index=0&id=75285a7a&scoped=true&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75285a7a"]])

export default __exports__